import { getCookie } from "@/app/utils/cookie-utils"

// Cookies first-party posés par le middleware. Noms littéraux pour rester indépendant des
// ajouts d'enum de la PR #672 : gclid est présent aujourd'hui, les trois autres arrivent avec elle.
const CLICK_ID_COOKIES = {
    gclid: "rm_gclid",
    fbclid: "rm_fbclid",
    msclkid: "rm_msclkid",
    ttclid: "rm_ttclid",
} as const

export type ClickIds = Partial<Record<keyof typeof CLICK_ID_COOKIES, string>>

export function readClickIds(): ClickIds {
    const ids: ClickIds = {}
    for (const [key, cookie] of Object.entries(CLICK_ID_COOKIES)) {
        const value = getCookie(cookie)
        if (value) {
            ids[key as keyof ClickIds] = value
        }
    }
    return ids
}

// Propage les click-IDs disponibles en query params sur le lien affilié, sans écraser l'existant.
export function appendClickIds(url: string): string {
    const entries = Object.entries(readClickIds())
    if (entries.length === 0) {
        return url
    }
    try {
        const parsed = new URL(url)
        for (const [key, value] of entries) {
            if (!parsed.searchParams.has(key)) {
                parsed.searchParams.set(key, value as string)
            }
        }
        return parsed.toString()
    } catch {
        return url
    }
}
